module.exports = __webpack_public_path__ + "static/psy-exp-485d5d0de02543bf6dfdf0bfc36efe4b.svg";